export default "__VITE_ASSET__4FKDGvC1__"